import React from "react";
//#region types
import { TopCardContentSkeletonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Divider, Grid, Skeleton } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TopCardContentSkeleton: React.FC<TopCardContentSkeletonProps> = (props) => {
  const {
    hideTitle,
    hideSubTitle,
    hideDescriptionHeadingOne,
    hideDescriptionHeadingTwo,
    hideDescriptionheadingThree,
    hideFooterText,
    hasFooterButton,
  } = props;

  return (
    <Grid container direction="column" gap={2}>
      <Grid item container className={cssExports.topSection}>
        <Grid container spacing={0.5}>
          {!hideTitle && (
            <Grid item xs={12}>
              <Skeleton width="150px" height="32px" variant="rounded" />
            </Grid>
          )}
          {!hideSubTitle && (
            <Grid item xs={12}>
              <Skeleton width="70px" height="16px" variant="rounded" />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item>
        <Divider className={cssExports.dividerGray} />
      </Grid>
      <Grid item container rowGap={0.5} direction="column" className={cssExports.midSection}>
        {!hideDescriptionHeadingOne && (
          <Grid item container>
            <Skeleton width="200px" height="32px" variant="rounded" />
          </Grid>
        )}
        {!hideDescriptionHeadingTwo && (
          <Grid item container>
            <Skeleton width="100px" height="20px" variant="rounded" />
          </Grid>
        )}
        {!hideDescriptionheadingThree && (
          <Grid item container>
            <Skeleton width="70px" height="20px" variant="rounded" />
          </Grid>
        )}
      </Grid>
      {!hideFooterText && (
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          className={cssExports.bottomSection}
          height={hasFooterButton ? "32px" : undefined}
        >
          <Grid item>
            <Grid item container direction="row" spacing={1} wrap="nowrap">
              <Grid item>
                <Skeleton width="16px" height="16px" variant="rounded" />
              </Grid>
              <Grid item xs>
                <Skeleton width="200px" height="16px" variant="rounded" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default TopCardContentSkeleton;
